import { module } from 'angular';
import kidComponent from './kid.component';
import './kid.scss';

export default module('app')
	.component('kid', kidComponent)
	.name;
